import React, { ReactNode, useState } from "react";
import { AppShell, Navbar, Footer as MantineFooter, ScrollArea, Button } from "@mantine/core";
import { observer } from "mobx-react";
import Footer from "./footer";
import { TopMenu } from "./top-menu";
import { useParams } from "react-router-dom";
import theme from "../stores/theme";
import { useStyles } from "./app-container";
import { ViewSideBar } from "./view-side-bar";
import { Icon } from "../custom-components/icons";
import { faAlignLeft, faBars } from "@fortawesome/pro-duotone-svg-icons";

const ViewAppContainer = observer((props: { children: ReactNode }) => {
  const params = useParams<{ id: string; parent: string }>();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const { classes } = useStyles(isOpen);
  return (
    <React.Fragment>
      <AppShell
        navbar={
          <Navbar width={{ base: params.parent != null && isOpen ? theme.other?.siderBarWidth : 80 }} className={classes.navbarContainer}>
            <Navbar.Section className={classes.modules}>
              {isOpen ? <span>{params.parent}</span> : null}
              <Button size="md" className={classes.button} onClick={() => setIsOpen(!isOpen)}>
                <Icon icon={isOpen ? faAlignLeft : faBars} size="lg" />
              </Button>
            </Navbar.Section>
            <Navbar.Section className={classes.sidebar} grow component={ScrollArea}>
              {params.parent != null ? <ViewSideBar treeView={isOpen} onIconClick={() => setIsOpen(true)} /> : null}
            </Navbar.Section>
          </Navbar>
        }
        footer={
          <MantineFooter className={classes.footerContainer} height={36}>
            <Footer />
          </MantineFooter>
        }
        header={<TopMenu />}
        className={classes.appshellContainer}
      >
        {props.children}
      </AppShell>
    </React.Fragment>
  );
});

export default ViewAppContainer;
